import { growthBookConfig } from './growthBook.config'
import { loginConfig } from './login.config'
import { autoVasConfig } from './autoVas.config'
import { turnstileConfig } from './turnstile.config'

const conf = {
  prod: {
    // Analytics Keys (Client-side)
    segmentKey: {
      ackoSeo: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      ackoDrive: 'diuEtVmmIty3lnYuipmsohzpEGmGGR3J',
      homePage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      ackoBrand: 'h2tIdlVfvi0CmHIgXIA9K3OEJAT6IR5N',
      ackoCareer: 'FAHnZoRSv5GNU2BmEqUqddQTIB4Rked7',
      ackoShare: 'nFRoS1iJbl3an6jRzwncfuL6PmumnnRw',
      aboutUsPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      ackoEnterprise: 'Db7qg80zZq79SffgRblhPHcSuBwraILN',
      brandHubPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      mediaKitPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      reviewsTestimonialPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      dhoniPressRelease: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      teslaTestDriveBooking: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      carInsurancePage: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      challanScamAwareness: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      abhaFlowAndoid: 'vJXwQOHGnjGbFNkL4KMGKiTluCwsMddm',
      abhaFlowIos: 'OvCWcu9Inkiw7aCY0zy7wW8jvXh60abU',
    },

    // Captcha (Client-side)
    hcaptchaSitekey: '63e15280-5462-4d9d-9275-4d0632a362c3',
    turnstile: turnstileConfig.prod,
    apiService: 'https://www.acko.com',
    challanVas: 'https://central-vas-challan.internal.live.acko.com',
    // Public URLs (Client-side)
    ackoBaseUrl: 'https://www.acko.com',
    ackoDriveBaseUrl: 'https://www.ackodrive.com',
    accountsBaseUrl: 'https://accounts.acko.com',
    copilotUrl: 'https://www.acko.com/p/acko-assist-v2/chat?journey=acko',
    autoVasConfig: autoVasConfig.prod,
    // Public API Endpoints (Client-side)
    ackontentBaseUrl: 'https://www.acko.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.ackodrive.com',
    loginConfig: loginConfig.prod,
    growthBookConfig: growthBookConfig.prod,
    // Feature Configs (Client-side)
  },
  'pre-prod': {
    segmentKey: {
      ackoSeo: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      ackoDrive: 'diuEtVmmIty3lnYuipmsohzpEGmGGR3J',
      homePage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      ackoCareer: 'FAHnZoRSv5GNU2BmEqUqddQTIB4Rked7',
      ackoShare: 'nFRoS1iJbl3an6jRzwncfuL6PmumnnRw',
      aboutUsPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      brandHubPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      mediaKitPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      reviewsTestimonialPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      dhoniPressRelease: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      teslaTestDriveBooking: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      carInsurancePage: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      challanScamAwareness: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      abhaFlowAndoid: 'vJXwQOHGnjGbFNkL4KMGKiTluCwsMddm',
      abhaFlowIos: 'OvCWcu9Inkiw7aCY0zy7wW8jvXh60abU',
    },
    hcaptchaSitekey: '63e15280-5462-4d9d-9275-4d0632a362c3',
    turnstile: turnstileConfig.prod,
    autoVasConfig: autoVasConfig.prod,
    apiService: 'https://www.acko.com',
    challanVas: 'https://central-vas-challan.internal.live.acko.com',
    ackoBaseUrl: 'https://www.acko.com',
    ackoDriveBaseUrl: 'https://www.ackodrive.com',
    accountsBaseUrl: 'https://accounts.acko.com',
    copilotUrl: 'https://www.acko.com/p/acko-assist-v2/chat?journey=acko',
    ackontentBaseUrl: 'https://www.acko.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.ackodrive.com',
    loginConfig: loginConfig.prod,
    growthBookConfig: growthBookConfig.prod,
  },
  master: {
    segmentKey: {
      ackoSeo: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      ackoDrive: 'g3ap5Yu91V2qsHVvBpzaGvTY3DG0szUJ',
      homePage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoBrand: 'thfdUv8SdqfVn1y9VPeiJorqR1qaXECQ',
      ackoCareer: 'FAHnZoRSv5GNU2BmEqUqddQTIB4Rked7',
      ackoShare: 'a8oWLN0un0u9mge2DDceADPVMioecr9u',
      aboutUsPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoEnterprise: 'OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj',
      brandHubPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      mediaKitPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      reviewsTestimonialPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      dhoniPressRelease: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      teslaTestDriveBooking: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      carInsurancePage: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      challanScamAwareness: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      abhaFlowAndoid: 'K41GQ30jRzhChSdpxUpCy2Rk0kD5AWZ8',
      abhaFlowIos: '1ZsKDzGs8gJEZsTD9hcgaAnWondEUj1Z',
    },
    hcaptchaSitekey: '585c1d16-fccf-405e-8917-31308fa419f2',
    turnstile: turnstileConfig.master,
    autoVasConfig: autoVasConfig.master,
    ackoBaseUrl: 'https://www.ackodev.com',
    apiService: 'https://www.ackodev.com',
    challanVas: 'https://central-vas-challan-service-uat.internal.ackodev.com',
    ackoDriveBaseUrl: 'https://ad-customer-website.uat.ackodrive.com',
    accountsBaseUrl: 'https://accounts.ackodev.com',
    copilotUrl: 'https://www.ackodev.com/p/acko-assist-v2/chat?journey=acko',
    ackontentBaseUrl: 'https://www.ackodev.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.internal.ackodrive.com',
    loginConfig: loginConfig.master,
    growthBookConfig: growthBookConfig.master,
  },
  local: {
    segmentKey: {
      ackoSeo: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      ackoDrive: 'g3ap5Yu91V2qsHVvBpzaGvTY3DG0szUJ',
      homePage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoBrand: 'thfdUv8SdqfVn1y9VPeiJorqR1qaXECQ',
      ackoCareer: 'FAHnZoRSv5GNU2BmEqUqddQTIB4Rked7',
      ackoShare: 'a8oWLN0un0u9mge2DDceADPVMioecr9u',
      aboutUsPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoEnterprise: 'OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj',
      brandHubPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      mediaKitPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      reviewsTestimonialPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      dhoniPressRelease: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      teslaTestDriveBooking: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      carInsurancePage: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      challanScamAwareness: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      abhaFlowAndoid: 'K41GQ30jRzhChSdpxUpCy2Rk0kD5AWZ8',
      abhaFlowIos: '1ZsKDzGs8gJEZsTD9hcgaAnWondEUj1Z',
    },
    hcaptchaSitekey: '585c1d16-fccf-405e-8917-31308fa419f2',
    turnstile: turnstileConfig.local,
    autoVasConfig: autoVasConfig.local,
    ackoBaseUrl: 'https://www.ackodev.com',
    apiService: 'https://www.ackodev.com',
    challanVas: 'https://central-vas-challan-service-uat.internal.ackodev.com',
    ackoDriveBaseUrl: 'https://www.ackodrive.com',
    accountsBaseUrl: 'https://accounts.ackodev.com',
    copilotUrl: 'https://www.ackodev.com/p/acko-assist-v2/chat?journey=acko',
    ackontentBaseUrl: 'https://www.ackodev.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.internal.ackodrive.com',
    loginConfig: loginConfig.local,
    growthBookConfig: growthBookConfig.local,
  },
  dev: {
    segmentKey: {
      ackoSeo: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      ackoDrive: 'g3ap5Yu91V2qsHVvBpzaGvTY3DG0szUJ',
      homePage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoBrand: 'thfdUv8SdqfVn1y9VPeiJorqR1qaXECQ',
      ackoCareer: 'a8oWLN0un0u9mge2DDceADPVMioecr9u',
      ackoShare: 'a8oWLN0un0u9mge2DDceADPVMioecr9u',
      aboutUsPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      brandHubPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      mediaKitPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      reviewsTestimonialPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      dhoniPressRelease: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      teslaTestDriveBooking: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      carInsurancePage: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      challanScamAwareness: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      abhaFlowAndoid: 'K41GQ30jRzhChSdpxUpCy2Rk0kD5AWZ8',
      abhaFlowIos: '1ZsKDzGs8gJEZsTD9hcgaAnWondEUj1Z',
    },
    autoVasConfig: autoVasConfig.dev,
    hcaptchaSitekey: '585c1d16-fccf-405e-8917-31308fa419f2',
    turnstile: turnstileConfig.dev,
    ackoBaseUrl: 'https://www.ackodev.com',
    apiService: 'https://www.ackodev.com',
    challanVas: 'https://central-vas-challan-service-uat.internal.ackodev.com',
    ackoDriveBaseUrl: 'https://ad-customer-website.dev.ackodrive.com',
    accountsBaseUrl: 'https://accounts.ackodev.com',
    copilotUrl: 'https://www.ackodev.com/p/acko-assist-v2/chat?journey=acko',
    ackontentBaseUrl: 'https://www.ackodev.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service-uat.dev.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.internal.ackodrive.com',
    loginConfig: loginConfig.dev,
    growthBookConfig: growthBookConfig.dev,
  },
}

export const getConfig = envValue => conf[envValue]
